// Founding team section configuration
// Defines fields for team members with repeater pattern
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Schema for individual team member
const teamMemberSchema = z.object({
  name: z.string().min(1, 'El nombre es requerido'),
  role: z.string().min(1, 'El rol es requerido'),
  responsibilities: z.string().min(1, 'Las responsabilidades son requeridas'),
  relevantExperience: z.string().min(1, 'La experiencia es requerida'),
  dedication: z.string().min(1, 'La dedicación es requerida'),
});

// Validation schema for founding team section
export const foundingTeamSectionSchema = z.object({
  members: z.array(teamMemberSchema).min(1, 'Al menos un miembro es requerido'),
});

export type FoundingTeamSectionData = z.infer<typeof foundingTeamSectionSchema>;

// Section config
export const foundingTeamSection: SectionConfig = {
  id: 'foundingTeam',
  titleKey: 'Equipo fundador',
  descriptionKey: 'Información sobre los miembros del equipo fundador',
  validationSchema: foundingTeamSectionSchema,
  fields: [
    {
      name: 'members',
      type: 'repeater',
      label: 'Miembros del equipo',
      required: true,
      itemLabelPrefix: 'Miembro',
      //addButtonLabel: 'Añadir otro',
      itemFields: [
        {
          name: 'name',
          type: 'text',
          label: 'Nombre',
          placeholder: 'Nombre completo del miembro',
          required: true,
        },
        {
          name: 'role',
          type: 'text',
          label: 'Rol',
          placeholder: 'Cargo o rol en la startup',
          required: true,
        },
        {
          name: 'responsibilities',
          type: 'textarea',
          label: 'Responsabilidades',
          placeholder: 'Describe las responsabilidades principales...',
          required: true,
        },
        {
          name: 'relevantExperience',
          type: 'textarea',
          label: 'Experiencia relevante previa',
          placeholder: 'Describe la experiencia previa relevante...',
          required: true,
        },
        {
          name: 'dedication',
          type: 'select',
          label: 'Dedicación al proyecto',
          required: true,
          options: [
            { value: 'full-time', label: 'Full-time' },
            { value: 'part-time', label: 'Part-time' },
            { value: 'advisory', label: 'Advisory' },
          ],
        },
      ],
    },
  ],
};
